module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Manage')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/question"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Service Questions List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Service Questions Detail')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Service Questions Detail')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])])])]), _vm._l((_vm.questions), function(question, index) {
    return [_c('div', {
      staticClass: "row margin-top text-center"
    }, [_c('h3', [_vm._v("評価項目 " + _vm._s(index + 1))])]), _c('div', {
      staticClass: "row margin-top"
    }, [_vm._m(1, true), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('span', [_vm._v(_vm._s(question.attributes['service-question-category-name']))])])])]), _c('div', {
      staticClass: "row margin-top"
    }, [_vm._m(2, true), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.newLineContent(question.attributes['question-scene']))
      }
    })])])]), _c('div', {
      staticClass: "row margin-top"
    }, [_vm._m(3, true), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.newLineContent(question.attributes['question-content']))
      }
    })])])]), _c('div', {
      staticClass: "row margin-top"
    }, [_vm._m(4, true), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('span', [_vm._v(_vm._s(question.attributes['max-point']))])])])])]
  }), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info margin-right",
    on: {
      "click": function($event) {
        _vm.onClickEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Edit')))])]), _c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])])])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("タイトル")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("カテゴリー")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("評価して欲しいシーン")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("評価項目")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("評価点数（満点）")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b985b78!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MasterServiceQuestionDetail.vue
// module id = 775
// module chunks = 1